import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import QuestionsManagementContainer from '../components/questions/QuestionsManagementContainer';
import ContentManagementSidebar from '../components/content-management/ContentManagementSidebar';
import TableSkeleton from '../components/content-management/views/TableView/TableSkeleton';
import MobileSkeleton from '../components/content-management/views/MobileView/MobileSkeleton';
import { isAdminRole } from '../utils/roleHelpers';

const QuestionsManagement = ({ auth: { isAuthenticated, loading, user } }) => {
  // Show loading while auth is being checked
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 py-4 px-2 sm:py-8 sm:px-4 pb-20 md:pb-4">
        <div className="mx-auto bg-white rounded-lg shadow-sm flex flex-col md:flex-row max-w-full overflow-hidden">
          <ContentManagementSidebar
            activeTab="Questions"
            onTabChange={() => {}}
            isAdmin={false}
            isInstructor={false}
          />
          <div className="flex-1 border-t md:border-t-0 md:border-l border-gray-200 p-6 min-w-0 overflow-x-auto">
            <div className="space-y-6">
              {/* Header Skeleton */}
              <div className="flex justify-between items-center">
                <div className="h-8 w-48 bg-gray-200 rounded animate-shimmer"></div>
                <div className="h-10 w-20 bg-gray-200 rounded-lg animate-shimmer"></div>
              </div>

              {/* Desktop Skeleton */}
              <div className="hidden md:block">
                <TableSkeleton rowCount={10} activeTab="Questions" />
              </div>

              {/* Mobile Skeleton */}
              <div className="md:hidden">
                <MobileSkeleton cardCount={10} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Not authenticated - redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/auth" />;
  }

  // Only admins can access questions management
  if (!isAdminRole(user?.role)) {
    return <Navigate to="/dashboard" />;
  }

  return <QuestionsManagementContainer />;
};

QuestionsManagement.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps)(QuestionsManagement);
